import {
  IBankTransaction,
  ITransferTransaction,
  TCustomerDetails,
  TransactionTypeEnum
} from '@/services/types/TransactionData';
import { TTransactionHistory } from '../types/TransactionHistory';
import { getStatementDetails } from '@/utils/getStatementDetails';
import { isCredit } from './isCredit';
import { AccountType, AccountTypeEnum } from '@/context/types/Account';

// Transactor display name: prefer their preferred (display) name, fall back to their full customer name
const getTransactorName = (customer: TCustomerDetails | undefined) => {
  if (!customer) {
    return undefined;
  }

  return `${customer.preferredName ?? customer.firstName} ${customer.lastName}`.trim();
};

export const getTransactionDetails = (
  transaction: TTransactionHistory,
  accountType?: AccountType
) => {
  switch (transaction.type) {
    case TransactionTypeEnum.Bank: {
      const data = transaction.data as IBankTransaction;
      if (isCredit(data.sign)) {
        return {
          label: `To: ${transaction.wallet?.name}`,
          labelDescription: getStatementDetails(data)
        };
      } else {
        return {
          label: `From: ${transaction.wallet?.name}`,
          labelDescription: getStatementDetails(data)
        };
      }
    }
    case TransactionTypeEnum.Transfer: {
      const data = transaction.data as ITransferTransaction;

      if (isCredit(data.sign)) {
        return {
          label: `To: ${transaction.toWallet?.name}`,
          labelDescription: ''
        };
      } else {
        return {
          label: `From: ${transaction.wallet?.name}`,
          labelDescription: ''
        };
      }
    }
    case TransactionTypeEnum.Admin: {
      return {
        label: '',
        labelDescription: ''
      };
    }
    case TransactionTypeEnum.Purchase: {
      if (accountType === AccountTypeEnum.BUSINESS && transaction.card?.panEnd) {
        const transactorName = getTransactorName(transaction.details?.customer);
        if (transactorName) {
          return {
            label: `${transactorName}'s card`,
            labelDescription: `****${transaction.card?.panEnd}`
          };
        }
      }

      if (!transaction.card?.panEnd) {
        return {
          label: transaction.wallet?.name,
          labelDescription: ''
        };
      }
      return {
        label: transaction.wallet?.name,
        labelDescription: `Card ****${transaction.card?.panEnd}`
      };
    }
    case TransactionTypeEnum.TopUp:
    case TransactionTypeEnum.EmergePay: {
      return {
        label: `To: ${transaction.wallet?.name}`,
        labelDescription: ''
      };
    }
  }
};
